/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'ptc.pm.collaborators.title': 'Seus colaboradores',
  'ptc.pm.error-heading': 'Algo de errado aconteceu',
  'ptc.pm.error-image-alt-text': 'Um robô quebrado e várias pessoas ocupadas em seu conserto.',
  'ptc.pm.error-text':
    'Nós acompanhamos esses erros, mas não hesite em entrar em contato se a atualização não corrigir as coisas',
  'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} membro} other {{memberCount,number} membros}}',
  'ptc.pm.people': 'Pessoas',
  'ptc.pm.teams': 'Equipes',
  'ptc.pm.view-your-profile': 'Exibir seu perfil',
  'ptc.pm.your-teams.title': 'Suas equipes',
};
